import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { useClassNameMapper } from './ThemeProvider';
export default (function (className) {
  return /*#__PURE__*/React.forwardRef(function (p, ref) {
    var classNames = useClassNameMapper();
    return /*#__PURE__*/React.createElement("div", _extends({}, p, {
      ref: ref,
      className: classNames(p.className, className)
    }));
  });
});